/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React from "react";
import { Component } from "react";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import styled from "styled-components";
import Constant from "../../constants";
import Colors from "../../utils/Color";
import * as orderSelectors from "../../selectors/order";
import "./index.css";

const StyledContainer = styled.div`
  cursor: pointer;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background: lightgray;
`;

const SpaceBetweenContainer = styled.div`
  background: white;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  padding: 10px 15px;
  font-size: 0.9em;
`;

const StyledTitle = styled.span`
  color: black;
  font-size: 1em;
`;

const StyledText = styled.span`
  color: gray;
`;

class OrderListItem extends Component {
  getOrderStatusBackgroundColor = orderCode => {
    switch (orderCode.toLowerCase()) {
      case Constant.ORDER_CODE_PAID.toLowerCase():
        return Colors.paidColor;
      case Constant.ORDER_CODE_COMPLETED.toLowerCase():
        return Colors.completedColor;
      case Constant.ORDER_CODE_CANCELLED.toLowerCase():
        return Colors.cancelledColor;
      case Constant.ORDER_CODE_UNPAID.toLowerCase():
        return Colors.unpaidColor;
      case Constant.ORDER_CODE_EXPIRED.toLowerCase():
        return Colors.ORDER_CODE_CANCELLED;
      default:
        return "black";
    }
  };

  onItemClicked = () => {
    const { item, onItemClicked } = this.props;

    const orderID = orderSelectors.getOrderID(item);
    onItemClicked && onItemClicked(orderID);
  };

  render() {
    const { item } = this.props;

    const orderNumber = orderSelectors.getOrderNumber(item);
    const orderTotal = orderSelectors.getOrderTotal(item);
    const orderStatus = orderSelectors.getOrderStatusName(item);
    const orderCode = orderSelectors.getOrderStatusCode(item);
    const orderCurrency = orderSelectors.getOrderCurrencySymbol(item);
    const orderFinal = orderSelectors.getOrderTotalFinal(orderTotal);
    const orderRelative = orderSelectors.getOrderCheckoutDateTimeRelative(item);

    return (
      <StyledContainer onClick={() => this.onItemClicked()}>
        <SpaceBetweenContainer>
          <StyledTitle>
            <FormattedMessage
              id="order.item.title"
              values={{ order: orderNumber }}
            />
          </StyledTitle>
          <StyledText
            style={{
              color: this.getOrderStatusBackgroundColor(orderCode),
              textTransform: "uppercase"
            }}
          >
            {orderStatus}
          </StyledText>
        </SpaceBetweenContainer>
        <SpaceBetweenContainer style={{ marginTop: "1px" }}>
          <StyledText>
            <FormattedMessage
              id="order.total.amount"
              values={{ currency: orderCurrency, amount: orderFinal }}
            />
          </StyledText>
          <StyledText>{orderRelative}</StyledText>
        </SpaceBetweenContainer>
      </StyledContainer>
    );
  }
}

OrderListItem.propTypes = {
  item: PropTypes.object,
  onItemClicked: PropTypes.func
};

export default OrderListItem;



// WEBPACK FOOTER //
// ./src/components/OrderListItem/index.js